module.exports = __webpack_public_path__ + "static/media/-_approval list.72dfa9d1.png";